import { useQuery } from '@tanstack/react-query';
import { recurrentApplicationsGetSingle } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useRecurrentApplication = (
  publisherId: number | undefined,
  id: number
) =>
  useQuery({
    queryFn: () =>
      extractData(
        recurrentApplicationsGetSingle({
          path: { publisherId: publisherId!, id },
        })
      ),
    queryKey: ['recurrentApplication', id, publisherId],
    enabled: Boolean(publisherId),
  });
